// Basic
import PropTypes from 'prop-types';
// Components
import DetailsGrid from '@/common-utils/components/renders/detailsGrid/DetailsGrid';
import Entity from '@/common-utils/components/renders/entity/Entity';
import { Separator } from '@/common-utils/components/ui/separator';
// Common
import organizationFields from '@/app/modules/organizations/fields/organizationFields';
import sitesIp from '@/app/modules/organizations/enums/ConnectionPointsIp';
import PortTypes from '@/app/modules/organizations/enums/PortTypes';
import getTranslatedText from '@/common-utils/functions/getTranslatedText';
// Lang
import { nsOrganization } from '@/app/i18n/namespaces';

/**
 * @param root0
 * @param root0.organization
 * @param root0.organizationConnectionPointsFields
 * @param root0.filteredConnectionPoints
 * @returns {JSX} CustomPayConnectionPointsPanel
 */
function CustomPayConnectionPointsPanel({ organization, organizationConnectionPointsFields, filteredConnectionPoints }) {

    // Set parentKeys to null from the fields to flatten the fields object for the DetailsGrid component
    const connectionPointsDataToDisplay = {
        ipAddress: { ...organizationConnectionPointsFields?.ipAddress, parentKeys: null },
        port: { ...organizationConnectionPointsFields?.port, parentKeys: null }
    };

    // Constants
    const organizationWithFilteredConnectionPoints = {
        ...organization,
        [organizationFields.CONNECTION_POINTS.key]: filteredConnectionPoints
    };

    const getPortsCategories = (organizationData) => {
        const connectionPoints = organizationData[organizationFields.CONNECTION_POINTS.key];
        const res = {};
        return connectionPoints ? Object.values(PortTypes).reduce(
            (modules, { name, module: moduleName }) => {
                connectionPoints.forEach(port => {
                    if (port[organizationFields.CONNECTION_POINTS.PORT_TYPE.key].includes(name) && moduleName) {
                        modules[moduleName] = [...(modules[moduleName] || []), port].sort();
                    }
                }
                );
                return modules;
            },
            res
        ) : null;
    };

    const reformatConnectionPoints = (connectionPoint, siteIpValue) => {
        const ipMatches = connectionPoint.ipAddress === siteIpValue.ip;
        const entity = siteIpValue.customSite ?
            'details.connection_points.public_ip.custom_site'
            : siteIpValue.site ?
                'details.connection_points.public_ip.site'
                : 'details.connection_points.public_ip.no_site';

        const translationData = {
            ip: siteIpValue.ip,
            site: siteIpValue.customSite ?
                siteIpValue.customSite
                : siteIpValue.site ?
                    siteIpValue.site
                    : null
        };

        return {
            ...connectionPoint,
            [organizationFields.CONNECTION_POINTS.IP_ADDRESS.key]: ipMatches ?
                getTranslatedText(entity, nsOrganization, translationData) : ''
        };

    };

    return (
        organization[organizationFields.CONNECTION_POINTS.key] && organization[organizationFields.CONNECTION_POINTS.key].length > 0 ?

            <div className='custom-detail-user-container'>
                {
                    Object.keys(getPortsCategories(organizationWithFilteredConnectionPoints)).map((category, index) => {
                        return (
                            <div key={category}>
                                <Entity
                                    entity={`details.connection_points.port_type.${category}`}
                                    namespace={nsOrganization}
                                    className='flex text-lg font-semibold mt-2'
                                />
                                {getPortsCategories(organizationWithFilteredConnectionPoints)[category].map((connectionPoint, idx) => {
                                    // Find the site IP value that matches the connection point IP address
                                    const matchedSiteIp = Object.keys(sitesIp)
                                        .find((site) => connectionPoint.ipAddress === sitesIp[site].ip);
                                    // If a site IP value is found, use it, otherwise use an empty Ip address
                                    const siteIpValue = matchedSiteIp ? sitesIp[matchedSiteIp] : { ip: '' };

                                    return (
                                        <div key={connectionPoint.uuid}>
                                            <DetailsGrid
                                                data={reformatConnectionPoints(connectionPoint, siteIpValue)}
                                                fields={connectionPointsDataToDisplay}
                                            />
                                            {idx < getPortsCategories(organizationWithFilteredConnectionPoints)[category].length - 1 &&
                                                <Separator className='my-4' />
                                            }
                                        </div>
                                    );
                                })}
                                {index < Object.keys(getPortsCategories(organizationWithFilteredConnectionPoints)).length - 1 &&
                                    <Separator className='my-4' />
                                }
                            </div>
                        );
                    })
                }
            </div>

            : false
    );
}

CustomPayConnectionPointsPanel.propTypes = {
    organization: PropTypes.object.isRequired,
    organizationConnectionPointsFields: PropTypes.object.isRequired,
    filteredConnectionPoints: PropTypes.array.isRequired
};

export default CustomPayConnectionPointsPanel;